<template>
  <v-container fluid>
    <v-toolbar dense color="transparent" flat>
      <v-toolbar-title class="grey--text text--darken-2">
        <v-subheader>
          POS <v-icon>mdi-chevron-right</v-icon> Reporte de ventas agrupadas
        </v-subheader>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="openDrawer()">
        <v-icon>mdi-filter-cog</v-icon>
      </v-btn>
      <!-- <v-btn v-print="'#posTable'" icon>
        <v-icon>mdi-printer</v-icon>
      </v-btn> -->
      <download-excel :name="'POS-SALES-GROUP'" :before-generate="beforeDownload" :data="dataExcel">
        <v-btn icon>
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </download-excel>
    </v-toolbar>
    <v-row>
      <v-col>
        <OrderTable ref="posTable"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderTable from '@/components/reports/pos/SalesGroupTable.vue'
export default {
  components: { OrderTable },
  data: () => ({
    dataExcel: [],
  }),
  methods: {
    beforeDownload() {
      this.dataExcel = this.mapOrders(this.$refs.posTable.dataOrder)
    },
    openDrawer() {
      this.$refs.posTable.openDrawer()
    },
    mapOrders(data) {
      const body = data.map(e=>{
        return {
        "N° total de ordenes": e.count,
        "Cliente": e.client,
        "Correo": e.email,
        "Subtotal": ((e.subtotalAcum + e.discountAcum).toFixed(2)).replace('.', ','),
        "Impuestos": e.taxAcum.toFixed(2).replace('.', ','),
        "Descuento": e.discountAcum.toFixed(2).replace('.', ','),
        "Propina": e.tipAcum.toFixed(2).replace('.', ','),
        "Total": e.totalAcum.toFixed(2).replace('.', ','),
        }
      })
      return body
    }
  },
}
</script>